import { useEffect, useState } from "react";
import { NextPage, NextPageContext } from "next";
import ProductLevelOne from "@containers/ProductLevelOne";
import { getCatalogProductLevel } from "@libraries/api/product-level/product.repositories";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { localeKey } from "@constants/locale-key";

const PageProductLevelOne: NextPage<any> = ({ baseUrl, data, dataNavbar }) => {
  const [content, setContent] = useState<any>({});

  const getContentMessage = (e: MessageEvent) => {
    setContent(e.data);
  };

  useEffect(() => {
    if (content.id) {
      window.addEventListener("message", getContentMessage);
      return () => {
        window.removeEventListener("message", getContentMessage);
      };
    }
  }, []);

  return (
    <ProductLevelOne
      baseUrl={baseUrl}
      data={content.id ? content : data}
      dataNavbar={dataNavbar}
    />
  );
};

export async function getServerSideProps(context: NextPageContext) {
  const language = `${context.locale}`;
  const slug = `${context.query.level_one}`;
  const slugZero = `${context.query.level_zero}`;

  if (slug === 'chatbot') {
    return {
      redirect: {
        destination: `/${slugZero}/omni-channel-assistant`,
        permanent: true, // true: 308 || false: 307
      }
    };
  }

  const response = await getCatalogProductLevel(slug, language);
  const { data } = JSON.parse(JSON.stringify(response));

  // Redirect if user direct url to Product Level 1 which has children
  const { level, isHaveChild } = data;
  const isLevelProductHasChild = level === 1 && isHaveChild;

  // Check path parent if user modify its path
  const { data: levelOneList } = await getProductMenu({ level: 0 }, language);
  const isParentExist = levelOneList.find((item: any) => item.productSlug === slugZero);

  if (!response || !isParentExist || isLevelProductHasChild) {
    return {
      redirect: {
        destination: `/404`,
        permanent: false,
      },
    };
  }

  return {
    props: {
      title: data.metaTitle || null,
      description: data.metaDescription || null,
      imageUrl: data.productImage?.mediaPath || "",
      baseUrl: `//${context?.req?.headers.host}`,
      canonical: data.canonical,
      data,
      dataNavbar: levelOneList,
      ...(await serverSideTranslations(context.locale ?? "id", localeKey)),
    },
  };
}

export default PageProductLevelOne;
